import { Box, Button, useTheme } from "@mui/material";
type Props = {
  logoSrc: string;
  alt: string;
  text?: string;
  onClick?: () => void;
  disabled?: boolean;
  children?: React.ReactNode; // 👈 add this
};

export default function SocialLoginButton({
  logoSrc,
  alt,
  text,
  onClick,
  disabled,
  children,
}: Props) {
  const theme = useTheme();
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      variant="outlined"
      fullWidth
      sx={{
        width: "100%",
        maxWidth: "100%",
        position: "relative",
        height: 40,
        borderColor: "#dadce0",
        backgroundColor: theme.palette.common.white,
        color: "#3c4043",
        fontWeight: 500,
        fontSize: "0.875rem",
        textTransform: "none",
        borderRadius: "20px",
        "&:hover": { backgroundColor: "#f7f8f8", borderColor: "#dadce0" },
      }}
    >
      {/* Logo stays left */}
      <Box
        component="img"
        src={logoSrc}
        alt={alt}
        sx={{
          position: "absolute",
          left: 12,
          width: 18,
          height: 18,
          pointerEvents: "none",
        }}
      />
      {text && text}
      {children && (
        <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center" }}>
          {children}
        </Box>
      )}
    </Button>
  );
}
